<template>
    <v-container id="tarifs">
        <v-card>
            <v-card-title class="title_display" @click="show.tarifs=!show.tarifs">
                <v-layout justify-space-between>
                    <h2>
                        Grille tarifaire
                    </h2>
                    <v-icon large right>
                        {{ show.tarifs ? 'arrow_drop_down' : 'arrow_left' }}
                    </v-icon>
                </v-layout>
            </v-card-title>
            <transition name="fade">
                <v-container v-if="show.tarifs" fluid>
                    <template v-if="loading">
                        <v-flex xs12 style="display:flex; justify-content: center; align-items: center;">
                            <v-progress-circular
                                :size="150"
                                :width="4"
                                indeterminate
                                color="orange"
                            />
                        </v-flex>
                    </template>
                    <template v-else>
                        <v-flex xs12>
                            <h3 class="tarifs_title">
                                Enseignes (surface cumulée des supports)
                            </h3>
                        </v-flex>
                        <v-flex xs12 style="margin-bottom: 1em;">
                            <v-card>
                                <table>
                                    <tr class="orange_cell bottom_white_border">
                                        <td style="width:25%;">
                                            &nbsp;
                                        </td>
                                        <td style="width:15%">
                                            De 0 à 7 m²
                                            <template v-if="hasEnseigneOption()">
                                                <br>
                                                <span class="option">
                                                    {{ getTexteEnseigneOption() }}
                                                </span>
                                            </template>
                                        </td>
                                        <td style="width:15%;">
                                            De 7 à 12 m²
                                            <template v-if="hasEnseigneOption()">
                                                <br>
                                                <span class="option">
                                                    {{ getTexteEnseigneOption() }}
                                                </span>
                                            </template>
                                        </td>
                                        <td style="width:15%;">
                                            De 12 à 20 m²
                                        </td>
                                        <td style="width:15%;">
                                            De 20 à 50 m²
                                        </td>
                                        <td style="width:15%;">
                                            50 m² et +
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="orange_cell bottom_white_border">
                                            Montant en €
                                        </td>
                                        <tarif-cell-montant v-for="id in [1, 2, 3, 4, 5]" :key="id" :tarif_id="id"/>
                                    </tr>
                                    <tr>
                                        <td class="orange_cell">
                                            Réfaction en %
                                        </td>
                                        <tarif-cell-refaction v-for="id in [1, 2, 3, 4, 5]" :key="id" :tarif_id="id"/>
                                    </tr>
                                </table>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>
                            <h3 class="tarifs_title">
                                Dispositifs publicitaires (surfaces individuelles des supports)
                            </h3>
                        </v-flex>
                        <v-flex xs12 style="margin-bottom: 1em;">
                            <v-card>
                                <table>
                                    <tr class="orange_cell bottom_white_border">
                                        <td colspan="3">
                                            &nbsp;
                                        </td>
                                        <td>
                                            De 0 à 1,5 m²
                                        </td>
                                        <td>
                                            De 1,5 à 50 m²
                                        </td>
                                        <td>
                                            50 m² et +
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" rowspan="2" class="orange_cell bottom_white_border">
                                            Numérique
                                        </td>
                                        <td class="orange_cell bottom_white_border">
                                            Montant en €
                                        </td>
                                        <tarif-cell-montant v-for="id in [6,7,8]" :key="id" :tarif_id="id"/>
                                    </tr>
                                    <tr>
                                        <td class="orange_cell bottom_white_border">
                                            Réfaction en %
                                        </td>
                                        <tarif-cell-refaction v-for="id in [6,7,8]" :key="id" :tarif_id="id"/>
                                    </tr>

                                    <tr>
                                        <td colspan="2" rowspan="2" class="orange_cell">
                                            Non numérique
                                        </td>
                                        <td class="orange_cell bottom_white_border">
                                            Montant en €
                                        </td>
                                        <tarif-cell-montant v-for="id in [9,10,11]" :key="id" :tarif_id="id"/>
                                    </tr>
                                    <tr>
                                        <td class="orange_cell">
                                            Réfaction en %
                                        </td>
                                        <tarif-cell-refaction v-for="id in [9,10,11]" :key="id" :tarif_id="id"/>
                                    </tr>
                                </table>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>
                            <h3 class="tarifs_title">
                                Pré-enseignes (surfaces individuelles des supports)
                            </h3>
                        </v-flex>
                        <v-flex xs12 style="margin-bottom: 1em;">
                            <v-card>
                                <table>
                                    <tr class="orange_cell bottom_white_border">
                                        <td colspan="3">
                                            &nbsp;
                                        </td>
                                        <td>
                                            De 0 à 1,5 m²
                                        </td>
                                        <td>
                                            De 1,5 à 50 m²
                                        </td>
                                        <td>
                                            50 m² et +
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" rowspan="2" class="orange_cell bottom_white_border">
                                            Numérique
                                        </td>
                                        <td class="orange_cell bottom_white_border">
                                            Montant en €
                                        </td>
                                        <tarif-cell-montant v-for="id in [12,13,14]" :key="id" :tarif_id="id"/>
                                    </tr>
                                    <tr>
                                        <td class="orange_cell bottom_white_border">
                                            Réfaction en %
                                        </td>
                                        <tarif-cell-refaction v-for="id in [12,13,14]" :key="id" :tarif_id="id"/>
                                    </tr>

                                    <tr>
                                        <td colspan="2" rowspan="2" class="orange_cell">
                                            Non numérique
                                        </td>
                                        <td class="orange_cell bottom_white_border">
                                            Montant en €
                                        </td>
                                        <tarif-cell-montant v-for="id in [15,16,17]" :key="id" :tarif_id="id"/>
                                    </tr>
                                    <tr>
                                        <td class="orange_cell">
                                            Réfaction en %
                                        </td>
                                        <tarif-cell-refaction v-for="id in [15,16,17]" :key="id" :tarif_id="id"/>
                                    </tr>
                                </table>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>
                            <h3 class="tarifs_title">
                                Options de calcul
                            </h3>
                        </v-flex>
                        <v-flex xs12>
                            <v-card>
                                <v-container fluid>
                                    <v-layout row wrap>
                                        <v-flex v-for="option in getCurrentOptions" :key="option.id" xs12>
                                            <template v-if="[1,2].includes(option.option_calcul_taxe.id)">
                                                <v-checkbox
                                                    v-model="option.valeur"
                                                    :hide-details="true"
                                                    :label="`${option.option_calcul_taxe.libelle} (${option.option_calcul_taxe.id})`"
                                                    :disabled="!isGeneric()"
                                                />
                                            </template>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card>
                        </v-flex>
                    </template>
                </v-container>
            </transition>
        </v-card>
    </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TarifCellMontant from './TarifCellMontant.vue';
import TarifCellRefaction from './TarifCellRefaction.vue';

export default {
    components: {
        'tarif-cell-montant': TarifCellMontant,
        'tarif-cell-refaction': TarifCellRefaction,
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapState('collectivite', ['tarifs', 'options', 'tarifsUsed']),
        ...mapState('show', ['show']),
        ...mapGetters('collectivite',['getCurrentOptions']),
    },
    created() {
    },
    methods: {
        isGeneric() {
            return 'simulateur-generique' === this.$route.name;
        },
        hasEnseigneOption() {
            return this.getCurrentOptions.filter((option) => [1, 2].includes(option.option_calcul_taxe.id) && option.valeur).length;
        },
        getTexteEnseigneOption() {
            return `(voir option de calcul ${this.getCurrentOptions.filter((option) => [1, 2].includes(option.option_calcul_taxe.id) && option.valeur).map((option) => option.option_calcul_taxe.id).join(' ')})`;
        },
    },
};

</script>

<style scoped>
.option {
    font-style: italic;
    font-weight: lighter;
}
</style>



// WEBPACK FOOTER //
// src/components/Simulateur/Tarifs.vue